import handleError from "./handleError";

/**
 * @param {Response} response
 *
 * @return {Object} Parsed JSON response body
 * @throws {Error}  In case of HTTP status code >= 400
 */
export default function handleJSON(response) {
  return handleError(response).json();
}
